module.exports = __webpack_public_path__ + "static/media/qa.6038ec14.svg";